import { render, staticRenderFns } from "./InventoryArchive.vue?vue&type=template&id=ffbe4ab8&"
import script from "./InventoryArchive.vue?vue&type=script&lang=ts&"
export * from "./InventoryArchive.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports